import { createContext, useContext } from "react";

export const DmsAnalyticsContext = createContext(null);

export const useDmsAnalyticsContext = () => {
    const context = useContext(DmsAnalyticsContext);
    if (!context) {
        throw new Error("useDmsAnalyticsContext must be used within DmsAnalytics.Card");
    }
    return context;
};
